export interface CreditDebitType {
  [key: number]: string;
}
export const MATERIAL_TYPE = [
  { id: 2, name: "Agriculture" },
  { id: 74, name: "Alcoholic Beverage" },
  { id: 5, name: "Auto Parts" },
  { id: 85, name: "Bags" },
  { id: 14, name: "Beverages" },
  { id: 75, name: "Bundle / Rolls" },
  { id: 1, name: "Carton Box" },
  { id: 87, name: "Carton box / FMCG" },
{ id: 67, name: "Drum/barrel" },
  { id: 7, name: "Electronic Goods" },
  { id: 3, name: "Empty Bottle" },
  { id: 4, name: "Empty Cylinder" },
  { id: 73, name: "Engineering materials" },
  { id: 13, name: "FMCG" },
  { id: 81, name: "Footwears" },
  { id: 77, name: "Furniture" },
  { id: 69, name: "Garment bundle" },
  { id: 84, name: "Glass" },
  { id: 76, name: "Hardware (Door / Windows)" },
  { id: 72, name: "Hardware (Pipes / Tiles)" },
  { id: 78, name: "Industrial Goods" },
  { id: 82, name: "Kitchenware" },
  { id: 66, name: "Medicine" },
  { id: 8, name: "Milk Products" },
  { id: 80, name: "Packaging Materials" },
  { id: 9, name: "Paint" },
  { id: 65, name: "Pallet / Panel" },
  { id: 88, name: "Paper Bundle" },
  { id: 68, name: "Parcel" },
  { id: 71, name: "Plywood" },
  { id: 83, name: "Sack (Jute/Plastic)" },
  { id: 70, name: "Scrap" },
  { id: 86, name: "Solid Sheets" },
  { id: 79, name: "Textiles" },
  { id: 6, name: "Tyre" },
  { id: 10, name: "Waste Cloths" },
  { id: 11, name: "Waste Material" },
  { id: 12, name: "Other" },
];
export const literals = {
  POSTGRESS_ERROR_CODE: 22000,
  STATUS_CODE: {
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERROR: 500,
    METHOD_NOT_ALLOWED: 405,
  },
  TOPIC: {
    NEW_TRIP_CREATED: "Waiting For Truck",
    TRIP_POD_TYPE: "Trip Pod Type",
    INDENT_DUPLICATE: "Indent Duplicate"
  },
  COMMENT: {
    NEW_TRIP_CREATED: "New trip created",
    TRIP_POD_TYPE: "Trip Pod Type updated by system@fr8.in",
    INDENT_DUPLICATE_FROM: "Duplicate indent created from Trip ID:",
    INDENT_DUPLICATE_TO: "New trip created. Trip ID:"
  },
  EMPLOYEE_FUNCTION: {
    IT: 7,
    LEADERSHIP: 1
  },
  EMPLOYEE_FUNCTION_GROUP: {
    OPERATIONS: 3,
  },
  EMPLOYEE_TYPE_ID: {
    OFF_ROLE: 2,
  },
  // Agents in these employee function groups are mobile-only: they must not be
  // able to link a desktop/web session from the app.
  // 3 Operations, 4 HR, 8 GCC, 34 Operations-GCC, 35 Sales-GCC.
  WEB_ACCESS_RESTRICTED_FUNCTION_GROUPS: [3, 4, 8, 34, 35],
  EMPLOYEE_GRADE: {
    S1:1
  },
  CUSTOMER_PAN_TYPE:{
    INDIVIDUAL:1,
    COMPANY:2
  },
  CUSTOMER_TYPE_ID: {
    TRANSPORTER: 1,
    BROKER: 2,
    SHIPPER: 3,
    ENTERPRISE: 4,
    AGRI: 5
  },
  POD_TYPE: {
    "NO POD": 1,
    "SOFT POD": 2,
    "HARD POD": 3
  },
  ORIGIN: {
    BOOK: 10,
    TRACK: 5,
  },
  API_HEADERS: {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  },
  PARTNER_STATUS: {
    VERIFICATION: 1,
    REJECTED: 2,
    ACTIVE: 4,
    DEACTIVATED: 6,
    BLACKLISTED: 7,
    LEAD: 8,
    KYCPENDING: 9,
  },
  TRIP_STATUS: {
    ASSIGNED: 2,
    CONFIRMED: 3,
    REPORTED_AT_SOURCE: 4,
    INTRANSIT: 5,
    REPORTED_AT_DESTINATION: 6,
    CANCELLED: 7,
    DELIVERED: 9,
    INVOICED: 12,
    RECEIVED: 13,
    PAID: 14,
    CLOSED: 15,
    PODRECEIVED: 16,
    ALLOCATED: 17,
  },
  EMAIL_SOURCE: {
    AUTO: 1,
    MANUAL: 2
  },
  CUSTOMER_STATUS_ID: {
    BLACKLISTED: 6,
    REJECTED: 7,
    ACTIVE: 1,
    REVERIFICATION: 4,
    IN_ACTIVE: 5,
    LEAD: 8,
    VERIFICATION: 3,
    REGISTERED: 2,
    KYC_PENDING: 9,
  },
  TRUCK_STATUS: {
    CONFIRMED: 1,
    LOADING: 2,
    INTRANSIT: 3,
    UNLOADING: 4,
    WAITING_FOR_LOAD: 5,
    DEACTIVATED: 6,
    ASSIGNED:8,
    VERIFICATION: 13,
    BREAKDOWN:15,
    BLACKLISTED: 17,
    ALLOCATED: 18,
  },
  LEAD_TYPE: {
    MATCHED: 1,
    OTHERS: 2,
    ALL: 3,
    INTEREST: 5,
    AUTO_INTEREST: 6,
  },
  LEAD_CHANNEL: {
    TRACK: 1,
    APP: 2,
    OTHERS: 3,
    ALL: 4,
    CHAT: 5,
    BOOK: 6,
    OUTSOURCE: 7,
    EXCESS: 9,
    SYSTEM: 10,
    UNLOADING: 12,
  },
  DATE_FORMAT: "DD-MMM HH:mm",
  POSTGRES_DATE_TIME: "YYYY-MM-DDTHH:mm:ss",
  EXTRA_ADVANCE_LIMIT: 5000,
  DELETE_REASON: {
    TRIP_CONFIRMED: 1,
    TRUCK_CONFIRMED: 2,
    TRIP_DELETED: 3,
    EMPLOYEE_REJECTED: 4,
    STOP_SEARCH: 5,
    PARTNER_REJECTED: 6,
    START_SEARCH: 7,
    TRUCK_UNAVAILABLE: 8,
    BROADCAST_OFF: 9,
    CLEANUP: 10,
  },
  PRIOR_EXCEPTION_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
  },
  PARTNER_PAN_STATUS:{
    PENDING: 2,
    APPROVED: 1,
    REJECTED: 3,
  },
  PRIOR_EXCEPTION_ID: {
    PENDING: 1,
    APPROVED: 2,
  },
  CUSTOMER_TYPE: {
    BROKER: 2,
  },
  NOTIFICATION_TYPE: {
    interest: 1,
    partner_allocation: 2,
    partner_kyc_rejection: 3,
    driver_authentication_failure: 4,
    trip_rating_from_partner: 5,
    employee_claim_requested: 6,
    employee_claim_approved: 7,
    employee_claim_rejected: 8,
    employee_resignation_requested: 9,
    employee_resignation_approved: 10,
    employee_resignation_rejected: 11,
    employee_leave_requested: 12,
    employee_claim_comment: 13,
    employee_click_to_call: 14,
    employee_ticket_alert: 15,
    truck_not_tracking: 16,
    bank_expected_uptime: 17,
    branch_exception_approved: 18,
    branch_exception_rejected: 19,
    pod_lost: 20,
    removed_allocation: 21,
    lr_rejected: 22,
  },
  TRACKED_BY: {
    EMPLOYEE: { ID: 1, NAME: "EMPLOYEE" },
    PARTNER: { ID: 2, NAME: "PARTNER" },
    FASTAG: { ID: 10, NAME: "FASTAG" },
    UNLOADING: { ID: 12, NAME: "UNLOADING" },
  },
  SYSTEM_MAIL: "system@fr8.in",
  REJECTION_REASON: {
    ALREADY_REGISTERED: { id: 1, name: "Already registered" }
  },
  TRUCK_MATCHING_TYPE: {
    START_SEARCH: "start_search",
    UNLOADING: "unloading",
    FASTAG: "fastag",
  },
  MATCHING_LEAST_COUNT: 10,
  TRUCK_TYPE: {
    TEN_WHL_OPEN: 7,
    TWELVE_WHL_OPEN: 18,
    FOURTEEN_WHL_OPEN: 33,
  },
  LOW_FREQUENCY_MATCHING_COUNT: 5,
  MAX_MATCHING_COUNT: 30,
  ACTIVE_TRIP_STATUS: [17, 2, 3, 4, 5, 6],
  TICKET_TYPE: {
    PRIOR_EXCEPTION: "Customer Prior Exception",
    BLACKLIST:"Blacklist"
  },
  ISSUE_CATEGORY_TYPE: {
    TRIP_CREDIT_DEBIT: 1,
    DRAFT_DISCREPANCY: 2,
    INVOICE_DISCREPANCY: 3,
    // matches ISSUE_CATEGORY_TYPE_INVOICE_CHARGES in validator-service/src/service/additionalInvoiceDebit.ts
    INVOICE_CHARGES: 4,
  },
  DEVICE_TYPE: {
    MOBILE: 1,
    WEB: 2,
    TABLET:3
  },
  role: {
    admin: "Admin",
    rm: "RM",
    accounts_manager: "Accounts Manager",
    billing_manager: "Billing Manager",
    partner_manager: "Partner Manager",
    partner_support: "Partner Support",
    sourcing_manager: "Sourcing Manager",
    accounts: "Accounts",
    onboarding: "Onboarding",
    billing: "Billing",
    bm: "BM",
    hr: "HR",
    zm: "ZM",
    user: "user",
    sourcing: "Sourcing",
    operations: "Operations",
    external: "outsource",
    finance_manager: "Finance Manager",
    customer_sales: "Customer Sales",
    customer_sales_manager: "Customer Sales Manager",
    tl_sales: "TL Sales",
  },
  CUSTOMER_CONSTANTS: {
    DEFAULT_ADVANCE_PERCENT: 90,
    SHIPPER_MAMUL: 0,
    DEFAULT_MAMUL: 1000
  },
  ALLOCATED_TYPE:{
    CHAT: 1,
    RM:4,
    DIRECT_PARTNER_ORDER:3
},
CHANNEL: {
  DIRECT: 1,
  SOCIAL_MEDIA: 2,
  REFERRAL: 3,
  APP: 4,
  TRACK: 5
},
CREDIT_DEBIT_TRIP_STATUS_IDS:[1, 2, 17],
ERROR_MESSAGES:{
  SUSPICIOUS_TRANSACTION:'Transaction Suspicious Contact Partner Support',
  CONTACT_ADMIN_APPROVAL:'Contact Admin/ZM for approval',
  CONTACT_RM_APPROVAL:'Contact Admin/ZM/RM for approval'
},
CREDIT_DEBIT_IDS: {
    COMMISSION_FEE: 9,
    LOADIND_HALTING: 7,
    TRIP_CANCELLATION: 16
  },

  CREDIT_DEBIT_ISSUE_TYPES: {
    "Loading Charges": "loading_charge",
    "Unloading Charges": "unloading_charge",
    "Loading Halting": "loading_halting",
    "Unloading Halting": "unloading_halting",
    "Price Difference": "price_difference",
  },
  
  CREDIT_DEBIT_STATUS :{
    APPROVED: 1,
    PENDING: 2,
    REJECTED: 3,
    SUBMIT_POD: 4
  },

  AUTHORIZATION_NAMES: {
    EWAY_BILL_EDIT_ACCESS: "eway_bill_edit_acess",
    CUSTOMER_MANAGER_ACCESS: "all_customer_leads_access",
    CONVERT_REJECTED_CUSTOMER_TO_LEAD: "convert_rejected_customer_to_lead",
    ADMIN_ACCOUNTS_MANAGER_ACCESS: "customer_lead_actions_access",
    ALL_PARTNER_LEADS_ACCESS: "all_partner_leads_access",
    CONVERT_REJECTED_PARTNER_TO_LEAD: "convert_rejected_partner_to_lead",
    PARTNER_LEAD_EDIT_ACCESS: "partner_lead_edit_access",
    PARTNER_REJECTED_LEAD_EDIT_ACCESS: "partner_rejected_lead_edit_access",
    PARTNER_LEAD_IFSC_CITY_UPDATE_ACCESS: "partner_lead_ifsc_city_update_access",
    PARTNER_LEAD_FAVOURITE_ACCESS: "partner_lead_favourite_access",
    PARTNER_LEAD_REASSIGN_ACCESS: "partner_lead_reassign_access",
    PARTNER_LEAD_ONBOARDING_ACCESS: "partner_lead_onboarding_access",
    PARTNER_KYC_MANUAL_APPROVE_ACCESS: "partner_kyc_manual_approve_access",
    PARTNER_ONBOARDED_BY_EDIT_ACCESS: "partner_onboarded_by_edit_access",
    CUSTOMER_PAN_GST_EDIT: "customer_pan_gst_edit",
    ALL_EXCEPTIONS_ACCESS : 'allow_exception_appproval',
    EXCEPTION_APPROVER_ACCESS: 'exception_approver',
    SINGLE_TRIP: "single_trip",
    APPROVE_KYC_SINGLE_TRIP: "approve_kyc_single_trip",
    UNBLACKLIST_PARTNER: "unblacklist_partner",
    CUSTOMER_DETAIL: 'customer_detail',
    ADDITIONAL_ADVANCE_IN_SPLIT_ADVANCE_TRIPS: 'additional_advance_for_split_advance_trips',
    DEBIT_NOTE_CREATION: 'debit_note_creation',
    DEBIT_NOTE_APPROVAL: 'debit_note_approval',
    DEBIT_NOTE_ZERO_APPROVAL: 'debit_note_zero_approval',
    UPI_PAYMENT_LINK_GENERATION_ACCESS: 'trip_upi_payment_link_generation_access',
    TRUCK_NO_CHANGE_ACCESS: 'truck_no_change_access',
    TRUCK_TYPE_CHANGE_ACCESS: 'truck_type_change_access',
    TRUCK_EDIT_ACCESS: 'truck_manager_edit_access',
    TRUCK_SOURCING_EDIT_ACCESS: 'truck_sourcing_edit_access',
    INCENTIVE_REVERSAL_APPROVAL: 'incentive_reversal_approval'
  },
  CUSTOMER_FAVOURITE_FILTER_OPTIONS: [
    {
        id: 1,
        name: 'Favourite',
        value: true,
    },
    {
        id: 2,
        name: 'Unfavourite',
        value: false
    },
  ],
  KYC_APPROVAL_TYPE: [
    {
        id: 1,
        name: 'Auto',
    },
    {
        id: 2,
        name: 'Manual',
    },
  ],
  PARTNER_LEAD_STATUS_OPTIONS: [
    { id: 1, name: 'Verification' },
    { id: 9, name: 'KYC Pending' },
    { id: 8, name: 'Lead' },
    { id: 2, name: 'Rejected' },
  ],
  PARTNER_FAVOURITE_FILTER_OPTIONS: [
    { id: 1, name: 'Favourite' },
    { id: 2, name: 'Unfavourite' },
  ],
  PARTNER_RE_KYC_OPTIONS: [
    { id: 1, name: 'Re-KYC' },
    { id: 2, name: 'New' },
  ],
  PARTNER_TRACKED_UNTRACKED_OPTIONS: [
    { id: 1, name: 'Tracked' },
    { id: 2, name: 'Untracked' },
  ],
  SINGLE_TRIP_MESSAGE:{
    ENABLE: "Single Trip Deactivation Enabled",
    DISABLE: "Single Trip Deactivation Disabled",
    APPROVE_KYC_SINGLE_TRIP:{
      ENABLE: "Truck activated and Single Trip Deactivation Enabled",
      DISABLE: "Truck activated",
    }
  },
  common_error_messages: {
    truck:{
      kyc_not_submitted: "KYC not submitted",
      auto_kyc_verify_failed: 'Auto KYC verify failed',
      rc_documents_are_mandatory: "RC documents are mandatory",
      truck_is_not_mapped_with_a_pan: "Truck is not mapped with a PAN",
    },
    partner:{
      partner_not_active: "Partner not active"
    },
    dont_have_access:"Do not have access",
    trip: {
      trip_lock: 'Transaction lock',
    },
  },
  DOCUMENT_TYPE: {
    rc_document_type: 'RC',
    rc_pan_consent: 'Y',
    rc_consent_purpose: 'For getting Rc name purpose only'
  },
    RC_STATUS: {
    BLACKLISTED: 'Blacklisted',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive'
  },
  BLACKLIST_TYPE_ID: {
    USER_REQUEST: 2   
  },
  MENU_ORDER: [
    "Home",
    "Organization",
    "Dashboard",
    "Incentive",
    "Reports",
    "Rates",
    "Chat",
    "Tickets",
    "Linked device",
    "Create customer",
    "Indent",
     "Help",
    "Delete account",
  ],
  PARTNER_BANK_APPROVAL_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    DELETED: 4
  },
  PENNY_TESTING_STATUS: {
    SUCCESS: 1,
    FAILED: 3,
    MANUALLY_APPROVABLE: 2,
  }
};

export const CREDIT_DEBIT_TYPE: CreditDebitType = {
  7: "Loading Halting",
  9: "Hiring Charge",
};
